import axios from 'axios';

function setupCSRF() {
  axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector("meta[name=csrf-token]").content;
}

document.addEventListener('DOMContentLoaded', setupCSRF);
